import { ScanInfo } from './scanInfo';

export class TrackingData {
    courierName: string | undefined;
    trackingNumber: string | undefined;
    scans?: (ScanInfo)[] | null;
    websiteLink: string | undefined;
}
